export default __webpack_public_path__ + "static/media/SupportingEvidenceIcon.01b31bf7.svg";